import { motion } from "framer-motion";
import { BadgeCheck, MessageCircle, Phone, Scale, Truck } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, reportConversion, waLink } from "../../data/site";
import Reveal from "./Reveal";

export default function FinalCta() {
  return (
    <section
      data-testid="final-cta-section"
      className="relative overflow-hidden bg-gradient-to-br from-brand-deep via-brand to-brand-dark py-24 text-white md:py-32"
    >
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-white/70">
            Get Instant Quote
          </p>
          <h2 className="mt-5 max-w-3xl font-display text-4xl font-extrabold leading-[1.08] tracking-tight sm:text-5xl md:text-6xl">
            Sell Your Scrap Today &amp; Get the <span className="text-tangy">Best Price</span> in
            Bangalore
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/80 sm:text-lg">
            Free pickup. Same-day payment. One call away.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <motion.a
              href={PHONE_TEL}
              onClick={reportConversion}
              whileTap={{ scale: 0.97 }}
              data-testid="final-call-button"
              className="inline-flex items-center gap-2.5 rounded-full bg-tangy px-8 py-4 text-base font-semibold text-white shadow-lg shadow-black/20 transition-transform duration-200 hover:scale-[1.03]"
            >
              <Phone className="h-5 w-5" />
              Call {PHONE_DISPLAY}
            </motion.a>
            <motion.a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              onClick={reportConversion}
              whileTap={{ scale: 0.97 }}
              data-testid="final-whatsapp-button"
              className="inline-flex items-center gap-2.5 rounded-full bg-white px-8 py-4 text-base font-semibold text-brand-dark shadow-lg shadow-black/20 transition-transform duration-200 hover:scale-[1.03]"
            >
              <MessageCircle className="h-5 w-5" />
              WhatsApp Now
            </motion.a>
          </div>
          <div className="mt-9 flex flex-wrap items-center gap-x-7 gap-y-3 text-sm font-medium text-white/85">
            <span className="flex items-center gap-2">
              <BadgeCheck className="h-5 w-5 text-white/80" /> Best Price Guaranteed
            </span>
            <span className="flex items-center gap-2">
              <Scale className="h-5 w-5 text-white/80" /> Transparent Weighing
            </span>
            <span className="flex items-center gap-2">
              <Truck className="h-5 w-5 text-white/80" /> Free Pickup
            </span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
